module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"base":{"login_form":{"register_full":"Kostenfrei registrieren"}}}}}}')
  delete Component.options._Ctor
}
